import { XStack, Text } from "tamagui";
import { useWatch } from "react-hook-form";
import { colors } from "@styles/colors";

interface SubtotalProps {
  proPrice?: number;
}

export default function Subtotal({ proPrice = 0 }: SubtotalProps) {
  const currentQuantity = Number(useWatch({ name: "qty" }) || 0);
  const totalPrice = proPrice * currentQuantity;

  return (
    <XStack alignItems="center">
      <Text color={colors.gray} fontWeight="bold" fontSize={14}>
        小計 NT$
      </Text>
      <Text color={colors.primary} fontWeight="bold" fontSize={24} ml={4}>
        {totalPrice.toLocaleString()}
      </Text>
    </XStack>
  );
}
